"use client";

import { useTranslations } from "next-intl";

type StatusPopUpProps = {
    title: string;
    message: string;
    onClose: () => void;
    type?: "info" | "success" | "error";
};

export default function StatusPopUp({
    title,
    message,
    onClose,
    type = "info",
}: StatusPopUpProps) {

    const tMain = useTranslations("main");

    const buttonClass =
        type === "success" || type === "info"
            ? "bg-[#009aeb] hover:bg-[#0082c7]"
            : type === "error"
                ? "bg-[#d9534f] hover:bg-[#c9302c]"
                : "bg-[#4e4e4e] hover:bg-[#333333]";

    return (
        <div className="fixed inset-0 z-60 flex items-center justify-center bg-black/45 p-2 sm:p-4">

            <div className="w-full max-w-[440px] rounded-xl bg-white px-4 py-6 text-center shadow-sm sm:px-10 sm:py-8">

                <h2 className="mb-5 text-lg font-bold text-[#333333] sm:mb-6 sm:text-xl">
                    {title}
                </h2>

                {message ? (
                    <p className="mb-8 whitespace-pre-line text-sm leading-relaxed text-[#777777] sm:mb-10 sm:text-base">
                        {message}
                    </p>
                ) : null}

                <div className="flex justify-center">
                    <button
                        type="button"
                        onClick={onClose}
                        className={`min-w-[100px] cursor-pointer rounded-md px-4 py-2 text-sm font-normal text-white transition-colors sm:text-base ${buttonClass}`}
                    >
                        {tMain("confirm")}
                    </button>
                </div>

            </div>

        </div>
    );
}